import _ from 'lodash';
import { connect } from 'react-redux';
import { add, update, get, overrideMatchData } from '../../modules/ocr/ocrIngestionResult';
import { showErrors } from '../../modules/general';
import { bindActionCreators } from 'redux';

const mapStateToProps = (state, ownProps) => {
	const ocrIngestionResultId = _.get(ownProps, ['match', 'params', 'ocrIngestionResultId']);
	const ocrIngestionResult = ocrIngestionResultId
		? _.get(state.maps, ['ocrIngestionResult', ocrIngestionResultId])
		: undefined;

	return {
		ocrIngestionResult,
		userMap: state.maps.user,
		carrierMap: state.maps.carrier,
		supplierMap: state.maps.supplier,
		terminalMap: state.maps.terminal,
		resourceMap: state.maps.resource,
		stationDeliveryMap: state.maps.stationDelivery,
		stationInvoiceMap: state.maps.stationInvoice,
		ocrIngestionDocumentMap: state.maps.ocrIngestionDocument,
		rackTransferMap: state.maps.rackTransfer,
		bulkCustomerMap: state.maps.bulkCustomer,
		bulkDeliveryMap: state.maps.bulkDelivery,
		ocrGuideMap: state.maps.ocrGuide,
		stationMap: state.maps.station,
	};
};

const mapDispatchToProps = (dispatch) =>
	bindActionCreators(
		{
			ocrIngestionResultAdd: add,
			ocrIngestionResultUpdate: update,
			ocrIngestionResultGet: get,
			ocrIngestionResultOverrideMatchData: overrideMatchData,
			showErrors,
		},
		dispatch
	);

export default connect(mapStateToProps, mapDispatchToProps);
